<template>
  <div class="core-content">
    <title-bar
      title-light="核心"
      title="实力"
      desc="优秀团队 整合技术构成新模式"
    ></title-bar>
    <div class="item-list wrap">
      <core-item
        class="item"
        v-for="item in coreItems"
        :key="item.label"
        :src="item.icon"
        :label="item.label"
        :desc="item.desc"
      ></core-item>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import CoreItem from './components/CoreItem'

import BoxIcon from '@/assets/images/home/core-content/box.svg'
import CoreIcon from '@/assets/images/home/core-content/core.svg'
import TeamIcon from '@/assets/images/home/core-content/team.svg'
import DiamondIcon from '@/assets/images/home/core-content/diamond.svg'

export default {
  name: 'CoreContent',
  data () {
    return {
      coreItems: [{
        icon: BoxIcon,
        label: '本地独家',
        desc: '温州鹿城区唯一调查服务公司我们熟悉这里因为我们源于这里'
      }, {
        icon: CoreIcon,
        label: '专业人士',
        desc: '我们的团队负责人，都拥有多年经验'
      }, {
        icon: TeamIcon,
        label: '先进技术',
        desc: '摆脱老旧模式，将先进技术与调查结合独家首创，自主研发应用，高效高质'
      }, {
        icon: DiamondIcon,
        label: '优秀团队',
        desc: '专业团队为每位客户提供服务不同项目不同的专业团队负责相同的服务质量'
      },]
    }
  },
  components: {
    TitleBar,
    CoreItem
  }
}
</script>

<style lang="less" scoped>
.core-content {
  padding: 70px 0;
  background-color: #f7f8fc;
  .item-list {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-top: 60px;
    .item {
      flex: 1;
    }
  }
}
</style>
